export const STATUS_LABEL = {
  nouveau: "Nouveau", a_qualifier: "À qualifier", qualifie: "Qualifié", a_contacter: "À contacter", contacte: "Contacté",
  a_relancer: "À relancer", interesse: "Intéressé", converti: "Converti en client", non_interesse: "Non intéressé", exclu: "Exclu",
};

export const CLASS_META = {
  tres_elevee: { label: "Priorité très élevée", color: "#22C55E" },
  elevee: { label: "Priorité élevée", color: "#00E5FF" },
  a_examiner: { label: "À examiner", color: "#F5A623" },
  faible: { label: "Priorité faible", color: "#8A8A93" },
};

export const CONF_LABEL = { elevee: "Élevée", moyenne: "Moyenne", faible: "Faible" };

export const PROC_COLOR = {
  rj: "#F97316", sauvegarde: "#F5A623", plan_redressement: "#00E5FF", plan_sauvegarde: "#00E5FF",
  liquidation: "#EF4444", cloture: "#8A8A93", resolution_plan: "#EF4444", other: "#8A8A93", none: "#3F3F46",
};

export const HIRING_LABEL = { faible: "Faible", modere: "Modéré", fort: "Fort", insuffisant: "Données insuffisantes" };
export const TREND_LABEL = { hausse: "↑ hausse", baisse: "↓ baisse", stable: "→ stable" };

export const TRANCHES = { 11: "10–19", 12: "20–49", 21: "50–99", 22: "100–199" };

export const fmtDate = (d) => (d ? new Date(d).toLocaleDateString("fr-FR") : "—");
export const fmtNum = (n) => (n ?? 0).toLocaleString("fr-FR");

export const ScorePill = ({ score, cls, testid }) => {
  const m = CLASS_META[cls] || CLASS_META.faible;
  return (
    <span data-testid={testid} title={m.label}
      className="inline-flex items-center justify-center min-w-[42px] px-2 py-0.5 rounded-full text-xs font-bold font-mono border"
      style={{ color: m.color, borderColor: `${m.color}66`, background: `${m.color}14` }}>
      {score ?? "—"}
    </span>
  );
};

export const ProcBadge = ({ legal }) => {
  const st = legal?.status || "none";
  if (st === "none") return <span className="text-xs text-muted">Aucune connue</span>;
  return (
    <span className="inline-flex items-center gap-1 text-xs font-medium" style={{ color: PROC_COLOR[st] }}>
      <span className="w-1.5 h-1.5 rounded-full" style={{ background: PROC_COLOR[st] }} />
      {legal.label}{legal.verified ? "" : " · à vérifier"}
    </span>
  );
};
